import Input from "@/wmCompoments/input";
import React, { useEffect } from "react";
import styles from '../styles/contentDescribe.module.scss'
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
}
const ContentDescribe = (props: Props) => {
    const { t } = useTranslation('feedback')
    
    const { name } = props

    const {
        register,
        setValue,
        watch,
        trigger,
        formState: { errors },
    } = useFormContext();

    const value = watch(name);

    // 注册字段及校验规则
    useEffect(() => {
        register(name, {
            required: t('enterDesc'),
            validate: (v) => {
                if (v?.length < 20)
                    return t('descTooShort')
            }
        });
    }, [register, name]);

    return <div className={styles.warpper}>
        <div>
            <div>
                <span className={styles.required}>*</span>
                <span>{t('issueDesc')}</span>
            </div>
            <span className={styles.limitText}>{t('descLengthLimit')}</span>
        </div>
        <div className={styles.content}>
            <textarea onChange={(e) => {
                setValue(name, e.target.value)
            }} maxLength={200} placeholder={t('descTip')} />
            <span>{value?.length ?? 0}/200</span>
        </div>
        {errors[name] && (
            <div className={styles.errorText}>{errors[name]?.message?.toString()}</div>
        )}
    </div>
}

export default ContentDescribe